var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInstagramIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 35,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.078 13.953a1.028 1.028 0 1 0 0-2.055 1.028 1.028 0 0 0 0 2.055"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.1 17.501a4.401 4.401 0 1 0 8.802 0 4.401 4.401 0 0 0-8.803 0m7.257 0a2.857 2.857 0 1 1-5.714 0 2.857 2.857 0 1 1 5.714 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.778 2.95a17.5 17.5 0 1 1 19.444 29.1A17.5 17.5 0 0 1 7.778 2.95m2.59 7.418c.477-.478.954-.77 1.519-.99.543-.212 1.167-.359 2.083-.397.913-.042 1.206-.052 3.533-.052s2.62.01 3.534.052 1.536.185 2.08.397c.564.22 1.041.512 1.519.99.474.474.766.955.986 1.516.209.543.355 1.167.397 2.08s.052 1.206.052 3.534-.01 2.621-.052 3.534-.184 1.537-.397 2.08a4.2 4.2 0 0 1-.99 1.52c-.477.478-.954.77-1.519.99-.543.209-1.167.355-2.08.397s-1.206.052-3.533.052-2.62-.01-3.533-.052-1.537-.185-2.08-.397a4.2 4.2 0 0 1-1.52-.99 4.2 4.2 0 0 1-.989-1.52c-.209-.543-.355-1.167-.397-2.08s-.052-1.206-.052-3.534.01-2.62.052-3.534.185-1.537.397-2.08c.22-.561.512-1.042.99-1.516",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstagramIcon);
export default ForwardRef;